import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { Station } from 'src/tmc-yard/client/model/station';
import { LoadingZoneReference } from 'src/tmc-yard/client/model/station-usage.model';

@Component({
  selector: 'app-loading-zone-selection',
  templateUrl: './loading-zone-selection.component.html',
  styleUrls: ['./loading-zone-selection.component.scss']
})
export class LoadingZoneSelectionComponent implements OnInit {

  station: Station;

  selected: LoadingZoneReference;

  constructor(
    public translationService: TranslationService,
    private dialog: MatDialogRef<LoadingZoneSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.station = data.station;

  }

  setSelected(loadingZone: LoadingZoneReference) {
    this.selected = loadingZone;
  }

  ngOnInit(): void {
  }

  confirm() {
    this.dialog.close(this.selected);
  }

  close() {
    this.dialog.close(null);
  }

}
